import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_118_3567)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.98462 4.98462V20.9354",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.9415 4.98462V13.9569",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.98462 4.98462C5.9077 4.06154 7.16308 3.54462 8.45539 3.54462C9.7477 3.54462 11.0031 4.06154 11.9262 4.98462C12.8492 5.90769 14.1046 6.42462 15.3969 6.42462C16.6892 6.42462 17.9446 5.90769 18.8677 4.98462",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.98462 13.9569C5.9077 13.0339 7.16308 12.5169 8.45539 12.5169C9.7477 12.5169 11.0031 13.0339 11.9262 13.9569C12.8492 14.88 14.1046 15.3969 15.3969 15.3969C16.6892 15.3969 17.9446 14.88 18.8677 13.9569",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.76001 4.43076H7.75386",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.76001 8.38153H7.75386",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.79688 12.3692H7.79072",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.75391 10.3754H9.74775",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.75391 6.42462H9.74775",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.74768 12.3692H11.7415",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.74768 8.38153H11.7415",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.74768 4.50461H11.7415",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7416 14.1046H13.7354",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7416 10.3754H13.7354",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7416 6.42462H13.7354",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7354 12.3692H15.7292",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7354 8.38153H15.7292",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7292 10.3754H17.7231",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7292 14.3631H17.7231",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7292 6.42462H17.7231",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.723 8.38153H19.7169",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.723 12.3692H19.7169",
				stroke: "CurrentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_118_3567",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgOnLocation;
